import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment Call_getMyCampaigns on Campaign {
      secondaryCallToAction {
        id
        type
        data
      }
    }
  `,
};
